import React, { useState } from 'react';
import cogoToast from 'cogo-toast';

import { getThresholds, saveThresholds, DEFAULT_THRESHOLDS, THRESHOLD_FIELDS } from '../../../helpers/spotlights_dashboard_helpers';

// UI-only alert thresholds. Stored per-admin in localStorage and applied client-side to drive
// the "needs attention" highlighting across the Overview / Brands / Creators tabs. These do NOT
// affect the daily Slack digest or any server-side alerting.
const SpotlightsSettings = () => {
  const [values, setValues] = useState(getThresholds());
  const [dirty, setDirty] = useState(false);

  const toInputValue = (key, type) => {
    if (type === 'pct') return Math.round((values[key] || 0) * 100);
    return values[key];
  };

  const onChange = (key, type, raw) => {
    let v = Number(raw);
    if (Number.isNaN(v)) return;
    if (type === 'pct') v = v / 100;
    setValues({ ...values, [key]: v });
    setDirty(true);
  };

  const save = () => {
    saveThresholds(values);
    setDirty(false);
    cogoToast.success('Thresholds saved (this browser only).');
  };

  const reset = () => {
    setValues({ ...DEFAULT_THRESHOLDS });
    saveThresholds({ ...DEFAULT_THRESHOLDS });
    setDirty(false);
    cogoToast.success('Reset to defaults.');
  };

  return (
    <div className='spotlights-settings'>
      <div className='sl-section'>
        <div className='sl-section-title'>Alert thresholds</div>
        <p className='sl-card-sub' style={{ marginBottom: 16 }}>
          These control the in-dashboard “needs attention” highlighting only. They’re saved in this browser and don’t change the daily Slack digest or
          any server-side alerting.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {THRESHOLD_FIELDS.map(f => (
            <div key={f.key} className='sl-card'>
              <div className='sl-card-label'>{f.label}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0' }}>
                <input
                  type='number'
                  step={f.type === 'roas' ? '0.1' : '1'}
                  value={toInputValue(f.key, f.type)}
                  onChange={e => onChange(f.key, f.type, e.target.value)}
                  style={{ width: 110, padding: 8, borderRadius: 8, border: '1px solid #f2f2f2' }}
                />
                <span style={{ color: '#4a4a4a', fontSize: 13 }}>{f.type === 'pct' ? '%' : f.type === 'roas' ? 'x' : ''}</span>
              </div>
              <div className='sl-card-sub'>{f.help}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button className='sl-btn' onClick={save} disabled={!dirty}>
            Save thresholds
          </button>
          <button className='sl-btn secondary' onClick={reset}>
            Reset to defaults
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpotlightsSettings;
